var render = function render(_c, _vm) {
  return _c(
    "section",
    {
      staticClass: "padding-y-5xl",
      staticStyle: { overflow: "hidden", "background-color": "var(--white)" },
      attrs: { id: "hero" },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row roomy" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "column-12 tablet:column-8 laptop:column-7 position-relative",
            },
            [
              _c(
                "p",
                {
                  staticClass: "text-uppercase",
                  staticStyle: {
                    "letter-spacing": "var(--letter-spacing-2xl)",
                    "font-weight": "var(--font-weight-bold)",
                  },
                },
                [
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Last")]),
                  _vm._v("\n          updated:\n          "),
                  _c("time", { attrs: { datetime: _vm.props.lastUpdated } }, [
                    _vm._v(_vm._s(_vm.props.lastUpdatedFormatted)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("h1", { staticClass: "margin-top-0 margin-bottom-md" }, [
                _vm._v("Terms of Service"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "size-lg margin-bottom-0" }, [
                _vm._v(
                  '\n          By using the fontawesome.com web site ("Service"), or any services of Fonticons, Inc. ("Font Awesome"), you (the user of the Service, such user\'s\n          successors, agents, and assigns, and everyone in privity with such user are, hereafter, “You.” Together, You and Font Awesome are sometimes the\n          “parties”) are agreeing to be bound by the following terms and conditions ("Terms of Service").\n        '
                ),
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass:
                  "position-absolute display-none tablet:display-block laptop:display-none",
                staticStyle: {
                  top: "-2em",
                  right: "-33em",
                  height: "22em",
                  "max-width": "none",
                },
                attrs: {
                  src: "https://img.fortawesome.com/1ce05b4b/terms-illustration.svg",
                },
              }),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function (_c, _vm) {
    return _c(
      "div",
      {
        staticClass:
          "column-12 margin-bottom-xl tablet:margin-bottom-0 tablet:column-5 tablet:order-last text-center",
      },
      [
        _c("img", {
          staticClass:
            "display-inline-block tablet:display-none laptop:display-inline-block",
          attrs: {
            src: "https://img.fortawesome.com/1ce05b4b/terms-illustration.svg",
            alt: "",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }